import { render, staticRenderFns } from "./entire.vue?vue&type=template&id=2b90cd79&scoped=true"
import script from "./entire.vue?vue&type=script&lang=js"
export * from "./entire.vue?vue&type=script&lang=js"
import style0 from "./assets/css/ys-page.less?vue&type=style&index=0&prod&lang=less&external"
import style1 from "./entire.vue?vue&type=style&index=1&id=2b90cd79&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b90cd79",
  null
  
)

export default component.exports